import { ArticleParagraph2, Button, TooltipDesktop } from '@cian/ui-kit';
import {
  IconActionCopy16,
  IconFunctionalSettings16,
  IconSocialTelegram16,
  IconFunctionalShow16,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import * as styles from './index.css';
import { openShareModal } from '../../actions/shareCollection';
import { selectPage, selectResults } from '../../selectors';
import { selectSelectedFolder } from '../../selectors/folders';
import { selectFolderOffersCount } from '../../selectors/folders/selectFolderOffersCount';
import { selectIsSearcherOrSub } from '../../selectors/lkType/selectIsSearcherOrSub';
import { selectOfferShareSettings } from '../../selectors/shareCollection/selectOfferShareSettings';
import { selectShareTooltip } from '../../selectors/shareCollection/selectShareTooltip';
import { EShareOptions, shareFolder } from '../../thunk/favorites';
import { trackShareFolder } from '../FolderHeader/tracking';

export const ShareFolderActionsContainer = () => {
  const dispatch = useDispatch();

  const offersCount = useSelector(selectFolderOffersCount);
  const hasOffers = offersCount > 0;

  const selectedFolder = useSelector(selectSelectedFolder, shallowEqual);
  const { favoriteEntities } = useSelector(selectResults);
  const { isFetching } = useSelector(selectOfferShareSettings) || {};
  const shareTooltip = useSelector(selectShareTooltip);
  const page = useSelector(selectPage);

  const isSearcherOrSub = useSelector(selectIsSearcherOrSub);

  const handleTelegramClick = React.useCallback(() => {
    if (!isFetching || isFetching === 'idle') {
      dispatch(shareFolder(EShareOptions.ForwardToTelegram));
      trackShareFolder(page, favoriteEntities, 'ShareCollectionTelegram');
    }
  }, [dispatch, favoriteEntities, isFetching, page]);

  const handleCopyClick = React.useCallback(() => {
    if (!isFetching || isFetching === 'idle') {
      dispatch(shareFolder(EShareOptions.CopyLink));
      trackShareFolder(page, favoriteEntities, 'ShareCollectionLink');
    }
  }, [dispatch, favoriteEntities, isFetching, page]);

  const handlePreviewClick = React.useCallback(() => {
    if (!isFetching || isFetching === 'idle') {
      dispatch(shareFolder(EShareOptions.Preview));
      trackShareFolder(page, favoriteEntities, 'customer_view');
    }
  }, [dispatch, favoriteEntities, isFetching, page]);

  const handleSettingsClick = React.useCallback(() => {
    if (selectedFolder?.id) {
      dispatch(
        openShareModal({
          id: selectedFolder.id,
          name: selectedFolder.name,
        }),
      );
      trackShareFolder(page, favoriteEntities, 'collection_settings');
    }
  }, [dispatch, selectedFolder?.id, selectedFolder?.name, favoriteEntities, page]);

  return (
    <div className={styles['container']}>
      <ArticleParagraph2>Поделитесь подборкой с {isSearcherOrSub ? 'близкими' : 'клиентом'}:</ArticleParagraph2>
      <div className={styles['buttons_container']}>
        <section className={styles['left_block']}>
          <Button
            onClick={handleTelegramClick}
            disabled={!hasOffers || isFetching === EShareOptions.ForwardToTelegram}
            loading={isFetching === EShareOptions.ForwardToTelegram}
            size="XS"
            theme="fill_secondary"
            beforeIcon={<IconSocialTelegram16 color="current_color" />}
          >
            Telegram
          </Button>
          <TooltipDesktop open={shareTooltip.state === 'show'} placement="bottom" title={shareTooltip.text}>
            <Button
              onClick={handleCopyClick}
              disabled={!hasOffers || isFetching === EShareOptions.CopyLink}
              loading={isFetching === EShareOptions.CopyLink}
              size="XS"
              theme="fill_secondary"
              beforeIcon={<IconActionCopy16 color="current_color" />}
            >
              Скопировать ссылку
            </Button>
          </TooltipDesktop>
          <Button
            onClick={handlePreviewClick}
            disabled={!hasOffers}
            loading={isFetching === EShareOptions.Preview}
            size="XS"
            theme="fill_primary"
            beforeIcon={<IconFunctionalShow16 color="current_color" />}
          >
            {isSearcherOrSub ? 'Предпросмотр' : 'Посмотреть как клиент'}
          </Button>
        </section>
        <section className={styles['right_block']}>
          <Button
            onClick={handleSettingsClick}
            size="XS"
            theme="fill_secondary"
            beforeIcon={<IconFunctionalSettings16 color="current_color" />}
          >
            Настроить подборку
          </Button>
        </section>
      </div>
    </div>
  );
};
